export const workLocationFeatureKey = 'workLocation';

export type WorkLocationType = 'Office' | 'Home' | 'Other';

export type WorkLocationModel = {
  id: number;
  name: string;
  type: WorkLocationType;
  /** Localized label of the type, computed server-side. Read-only. */
  typeLoc: string;
  salesTeamId?: number | null;
  salesTeamName: string;
  /** Whether time spent here counts as worked. Carried by the location, not derived from the type. */
  countedAsWork: boolean;
  active: boolean;
};
